export const DATE_FORMATS = {
    api: "yyyy-MM-dd'T'HH:mm:ss",
    input: "yyyy-MM-dd'T'HH:mm",
    inputDatetime: "yyyy-MM-dd'T'HH:mm",
    inputDate: 'yyyy-MM-dd',
    inputTime: 'HH:mm',
    inputMonth: 'yyyy-MM',
    timeseries: {
      withSeconds: "yyyy-MM-dd'T'HH:mm:ss",
      withoutSeconds: "yyyy-MM-dd'T'HH:mm",
      withSecondsTable: 'yyyy.MM.dd HH:mm:ss',
      withoutSecondsTable: 'yyyy.MM.dd HH:mm',
    },
};
